import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MoreOutlinedSvg from "@ant-design/icons-svg/es/asn/MoreOutlined";
import AntdIcon from "../components/AntdIcon";
var MoreOutlined = function MoreOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MoreOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MoreOutlined.displayName = 'MoreOutlined';
}
export default /*#__PURE__*/React.forwardRef(MoreOutlined);